import { useLingui } from "@lingui/react/macro";
import { InfoIcon } from "lucide-react";
import React from "react";

import { cn } from "@/utils/shadcn-ui";

import { Tooltip } from "./tooltip";

export function HelperTooltip({
  className,
  content,
}: {
  className?: string;
  content: React.ReactNode;
}) {
  const { t } = useLingui();
  return (
    <Tooltip content={content} side="top">
      {/* A real button so keyboard users can focus it, which is what opens a
          Radix tooltip for them; the open tooltip becomes its description. */}
      <button
        type="button"
        aria-label={t`More information`}
        // Only keyboard focus should open it. A dialog whose first focusable
        // element this is focuses it on open, and the tooltip would cover the
        // dialog every time it's opened with the mouse. Radix skips its own
        // open-on-focus when the event is already default-prevented.
        onFocus={(e) => {
          if (!e.currentTarget.matches(":focus-visible")) e.preventDefault();
        }}
        className={cn(
          "inline-flex cursor-help rounded-sm bg-transparent p-0.5 align-middle focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none",
          className,
        )}
      >
        <InfoIcon className="text-muted-foreground size-3.5 shrink-0" />
      </button>
    </Tooltip>
  );
}
